import axios from 'axios';
import Config from '../Config';
import store from '@/store/index'
import ServiceUtils from "@/common/utils/ServiceUtils";

const domain = Config.getDomain();

let numberOfApiCallPending = 0;
const IS_SESSION_TIMEOUT = true;

const axiosInstance = axios.create({
    baseURL: domain,
    // timeout: 20000,
});

axiosInstance.defaults.headers.common['Pragma'] = 'no-cache';
axiosInstance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axiosInstance.interceptors.request.use(config => {
    if (ServiceUtils.detectUnsupportedBrowser()) {
        ServiceUtils.showUnsupportedBrowserModal();
        return ;
    }
    numberOfApiCallPending++;
    store.commit('axios/changeLoadingStatus', true);
    return config
}, error => {
    return Promise.reject(error);
});

axiosInstance.interceptors.response.use(response => {
    if (response && response.data === IS_SESSION_TIMEOUT) {
        window.location.reload();
    }

    numberOfApiCallPending--;
    if (numberOfApiCallPending === 0) {
        store.commit('axios/changeLoadingStatus', false);
    }
    if (ServiceUtils.checkMaintainModeEOW(response?.data)) {
        return false;
    }
    return response
}, error => {
    numberOfApiCallPending--;
    if (numberOfApiCallPending === 0) {
        store.commit('axios/changeLoadingStatus', false);
    }
    if (ServiceUtils.validateServerErrorHttpStatus(error.response?.status)) {
        return false;
    }
    return Promise.reject(error);
});

export default class BaseService {
    constructor(auth = 'user') {
        if (auth) {
            this.setAuth(auth)
        }
    }

    setAuth(auth) {
        axiosInstance.interceptors.request.use(function (config) {
            const user = JSON.parse(localStorage.getItem(auth));
            if (user) {
                config.headers.Authorization = `Bearer ${user.access_token}`
            }
            return config
        })
    }

    async get(uri, params = {}) {
        try {
            return await axiosInstance.get(this.url(uri), {params: params})
        } catch (e) {
            return this.errorMsg(e)
        }
    }

    async initHeader(uri) {
        try {
            return await axiosInstance.get(this.url(uri))
        } catch (e) {
            return this.errorMsg(e)
        }
    }

    async getByUri(uri) {
        try {
            return await axiosInstance.get(this.url(uri))
        } catch (e) {
            return this.errorMsg(e)
        }
    }

    async post(uri, data = {}, config = {}) {
        try {
            return await axiosInstance.post(this.url(uri), data, config)
        } catch (e) {
            return this.errorMsg(e)
        }
    }

    async postByUri(uri) {
        try {
            return await axiosInstance.post(this.url(uri))
        } catch (e) {
            return this.errorMsg(e)
        }
    }

    async put(uri, params = {}) {
        try {
            return await axiosInstance.put(this.url(uri), params)
        } catch (e) {
            return this.errorMsg(e)
        }
    }

    async patch(uri, params = {}) {
        try {
            return await axiosInstance.patch(this.url(uri), params)
        } catch (e) {
            return this.errorMsg(e)
        }
    }

    async show(uri) {
        try {
            return await axiosInstance.get(this.url(uri))
        } catch (e) {
            return this.errorMsg(e)
        }
    }

    async delete(uri) {
        try {
            return await axiosInstance.delete(this.url(uri))
        } catch (e) {
            return this.errorMsg(e)
        }
    }

    url(uri) {
        const publicPath = process.env.VUE_APP_PUBLIC_PATH_SERVER;
        let requestPath = publicPath + uri;
        requestPath = requestPath.replace(/\/\//g, "/");
        return domain + requestPath;
    }

    errorMsg(e) {
        if (e.response === undefined) {
            e.status = 0
            e.statusText = e.message
            return {data: e}
        }
        return {data: e.response}
    }
}
